<div class="container-dots">
  <generic-icon [iconVar]="'--x-brand-semi-dots'" ></generic-icon>
</div>
<div class="container-logo">
  <generic-icon [iconVar]="'--x-brand-mojix-source'" ></generic-icon>
</div>
